(() => {
  const pageTitle = 'Loyalty Rewards | Wild Wholistic';
  const iframeTitle = 'Wild Wholistic loyalty rewards';

  function ensureDocumentTitle(doc, titleText) {
    if (!doc?.head) return;

    let title = doc.head.querySelector('title');

    if (!title) {
      title = doc.createElement('title');
      doc.head.appendChild(title);
    }

    if (title.textContent.trim() !== titleText) {
      title.textContent = titleText;
    }
  }

  function hasAccessibleName(button) {
    const text = button.textContent?.trim();
    const ariaLabel = button.getAttribute('aria-label')?.trim();
    const labelledBy = button.getAttribute('aria-labelledby')?.trim();
    const title = button.getAttribute('title')?.trim();

    const imageAlt = [...button.querySelectorAll('img[alt]')]
      .some((image) => image.getAttribute('alt')?.trim());

    return Boolean(
      text ||
      ariaLabel ||
      labelledBy ||
      title ||
      imageAlt
    );
  }

  function applyLoyaltyAccessibilityFixes() {
    ensureDocumentTitle(document, pageTitle);

    const appstleIframe = document.querySelector(
      '#appstle_loyalty_cart_widget_iframe'
    );

    if (appstleIframe) {
      appstleIframe.setAttribute('title', iframeTitle);

      try {
        ensureDocumentTitle(
          appstleIframe.contentDocument,
          iframeTitle
        );
      } catch (error) {
        // The iframe may not be ready yet.
      }
    }

    const appstleButtons = [...document.querySelectorAll('button')]
      .filter((button) =>
        [...button.classList].some((className) =>
          className.startsWith('al-')
        )
      );

    let unnamedButtons = appstleButtons.filter(
      (button) => !hasAccessibleName(button)
    );

    const statusButton = unnamedButtons.find(
      (button) =>
        button.classList.contains('al-h-5') &&
        button.classList.contains('al-w-9')
    );

    if (statusButton) {
      statusButton.setAttribute(
        'aria-label',
        'Loyalty status'
      );
    }

    const navigationButtons = unnamedButtons.filter(
      (button) =>
        button.classList.contains('al-px-2.5') &&
        button.classList.contains('al-py-1')
    );

    if (navigationButtons[0]) {
      navigationButtons[0].setAttribute(
        'aria-label',
        'Previous reward'
      );
    }

    if (navigationButtons[1]) {
      navigationButtons[1].setAttribute(
        'aria-label',
        'Next reward'
      );
    }

    unnamedButtons = appstleButtons.filter(
      (button) => !hasAccessibleName(button)
    );

    if (unnamedButtons[0]) {
      unnamedButtons[0].setAttribute(
        'aria-label',
        'View rewards activity'
      );
    }
  }

  let scheduled = false;

  function scheduleFixes() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      applyLoyaltyAccessibilityFixes();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      applyLoyaltyAccessibilityFixes
    );
  } else {
    applyLoyaltyAccessibilityFixes();
  }

  const observer = new MutationObserver(scheduleFixes);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  setTimeout(applyLoyaltyAccessibilityFixes, 500);
  setTimeout(applyLoyaltyAccessibilityFixes, 1500);
  setTimeout(applyLoyaltyAccessibilityFixes, 3000);
})();